import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import Utilities from '@/Utility/Utilities';

export default class DummyColumnFactory extends ColumnFactory {

    public static isPlainText = true;
    public static isJQueryElement = false;

    constructor(params: any) {
        super(params);
    }

    public getValue(): string {
        if (Utilities.isNullOrUndefined(this.raw))
            return '';

        if (typeof this.raw == "string")
            return this.raw;

        return JSON.stringify(this.raw);
    }
}

ComponentManager.setFactory('DummyColumn', DummyColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');